// API configuration
export const API_CONFIG = {
  baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:8000',
  timeout: 10000,
}

export const API_ENDPOINTS = {
  // Auth endpoints
  LOGIN: '/api/auth/jwt/create/',
  REFRESH: '/api/auth/jwt/refresh/',
  VERIFY: '/api/auth/jwt/verify/',
  
  // User endpoints
  RESET_PASSWORD: '/api/v1/users/reset_password/',
  RESET_PASSWORD_CONFIRM: '/api/v1/users/reset_password_confirm/',
  USER_ME: '/api/v1/users/me/',
  
  // Management endpoints
  ENTERPRISES_LIST: '/api/v1/management/enterprise/',
  SET_ENTERPRISE: (id) => `/api/v1/management/enterprise/${id}/set_enterprise/`,
  
  // Handbooks endpoints
  HANDBOOKS: {
    POSITION: '/api/v1/handbooks/position/',
    POSITION_DETAIL: (id) => `/api/v1/handbooks/position/${id}/`,
    STAFFER: '/api/v1/handbooks/staffer/',
    STAFFER_DETAIL: (id) => `/api/v1/handbooks/staffer/${id}/`,
    DEPARTMENT: '/api/v1/handbooks/department/',
    DEPARTMENT_DETAIL: (id) => `/api/v1/handbooks/department/${id}/`,
    HARDWARE: '/api/v1/handbooks/hardware/',
    HARDWARE_DETAIL: (id) => `/api/v1/handbooks/hardware/${id}/`,
    RAW_STOCK: '/api/v1/handbooks/raw_stock/',
    RAW_STOCK_DETAIL: (id) => `/api/v1/handbooks/raw_stock/${id}/`,
    END_PRODUCT: '/api/v1/handbooks/end_product/',
    END_PRODUCT_DETAIL: (id) => `/api/v1/handbooks/end_product/${id}/`,
    PROVIDER: '/api/v1/handbooks/providers/',
    PROVIDER_DETAIL: (id) => `/api/v1/handbooks/providers/${id}/`,
    WORK_SCHEDULE: '/api/v1/handbooks/work_schedule/',
    WORK_SCHEDULE_DETAIL: (id) => `/api/v1/handbooks/work_schedule/${id}/`,
  },
  
  // Checklists endpoints
  CHECKLISTS: {
    // Templates
    TEMPLATES: '/api/v1/checklists/templates/',
    TEMPLATES_DETAIL: (id) => `/api/v1/checklists/templates/${id}/`,
    TEMPLATES_CLONE: '/api/v1/checklists/templates/clone/',
    
    // Instances
    INSTANCES: '/api/v1/checklists/instances/',
    INSTANCES_DETAIL: (id) => `/api/v1/checklists/instances/${id}/`,
    INSTANCES_UPDATE_ANSWERS: (id) => `/api/v1/checklists/instances/${id}/update_answers/`,
    INSTANCES_SUBMIT: (id) => `/api/v1/checklists/instances/${id}/submit/`,
    INSTANCES_DECLINE: (id) => `/api/v1/checklists/instances/${id}/decline/`,
    INSTANCES_REASSIGN: (id) => `/api/v1/checklists/instances/${id}/reassign/`,
    
    // Assignments
    ASSIGNMENTS: '/api/v1/checklists/assignments/',
    ASSIGNMENTS_DETAIL: (id) => `/api/v1/checklists/assignments/${id}/`,
    ASSIGNMENTS_DECLINE: (id) => `/api/v1/checklists/assignments/${id}/decline/`,
    
    // Tasks
    TASKS: '/api/v1/checklists/tasks/',
    TASKS_DETAIL: (id) => `/api/v1/checklists/tasks/${id}/`,

    // Calendar
    CALENDAR: '/api/v1/checklists/calendar/',
    CALENDAR_DAY: (date) => `/api/v1/checklists/calendar/${date}/`,
  },
}

// Mapping handbook routes to permission keys
export const HANDBOOK_PERMISSIONS_MAP = {
  positions: 'POSITION',
  employees: 'STAFFER',
  workshops: 'DEPARTMENT',
  equipment: 'HARDWARE',
  rawMaterials: 'RAW_STOCK',
  products: 'END_PRODUCT',
  suppliers: 'PROVIDER',
  workSchedule: 'WORK_SCHEDULE',
}
